import Member from "./member";

export function useMember() {
    const getMember = async (documentId)=>{
        const member = new Member();
        const query = {
            populate:{role:true, profileImage:true}
        };
        const response = await member.getById(documentId, query);
        return response?.data;
    }

    return {getMember};
}
